import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import { isKeyCombination } from '~libs.typescript';

import { translationKeys } from '../translations';

import { StyledSecondsLeft, StyledThumb, StyledTrack } from './EmergencyNotificationCountdown.styled';

const THREE_SECONDS = 3;

type EmergencyNotificationCountdownProps = Readonly<{
   close: VoidFunction;
   call: VoidFunction;
}>;

export const EmergencyNotificationCountdown = (props: EmergencyNotificationCountdownProps): JSX.Element => {
   const [secondsLeft, setSecondsLeft] = useState(THREE_SECONDS);

   useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent): void => {
         if (isKeyCombination(event, 'escape')) {
            event.preventDefault();
            props.close();
         }
      };
      document.body.addEventListener('keydown', handleKeyDown);
      return () => document.body.removeEventListener('keydown', handleKeyDown);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.close]);

   useEffect(() => {
      const interval = setInterval(() => {
         setSecondsLeft((prev) => {
            if (prev <= 1) {
               clearInterval(interval);
               props.call();
               return 0;
            }
            return prev - 1;
         });
      }, 1000);

      return () => clearInterval(interval);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.call]);

   return (
      <>
         <StyledTrack>
            <StyledThumb />
         </StyledTrack>
         <StyledSecondsLeft testId={'secondsLeft'}>
            <Trans
               i18nKey={translationKeys.sosWillBeSentInSeconds}
               values={{ seconds: secondsLeft }}
               components={{ bold: <strong /> }}
            />
         </StyledSecondsLeft>
      </>
   );
};
